import React from 'react'
import { HomePage } from 'src/features'
import BaseLayout from 'src/layouts'

const Home: React.FC = () => {
  return (
    <BaseLayout>
      <HomePage />
    </BaseLayout>
  )
}

export default Home
